import React, { Component } from "react";

import { withAuth } from "../../../shared/containers/containerAuth";
import getDates from "../../../shared/services/date.service";
import { DataGrid } from "@mui/x-data-grid";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import HistoryIcon from "@mui/icons-material/History";
import { withCompanies } from "../../../shared/containers/containerCompanies";
import styles from "./cmsCompanyTable.module.scss";
import clsx from "clsx";
import "./cellTable.css";
import { withDevices } from "../../../shared/containers/containerDevices";
import { states } from "../../../reducers/queriesStates";
import { dateGridLocalTextOptions } from "../../../shared/services/dataGridLocalTextOptions";
import ButtonIconWrapper from "../../../shared/items/contols/buttonIconWrapper";
import { Radio } from "@mui/material";
import Preloader from "../../../shared/items/static/preloader";

class CmsCompanyTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeType: 0,
      rentType: 0,
    };
  }

  componentDidMount() {
    const { dataStateProtocolMarkers, onGetProtocolMarkers } = this.props;

    if (dataStateProtocolMarkers === states.NOT_REQUESTED) {
      onGetProtocolMarkers();
    }
  }

  getUnits() {
    const { company } = this.props;
    let units = [];

    company.units.forEach((unit) => {
      const rows = [];

      unit.devices.forEach((device) => {
        let mobileOpertor = "";

        if (device.numberSim !== null && device.numberSim.length === 19) {
          mobileOpertor = "A1";
        }

        if (device.numberSim !== null && device.numberSim.length === 20) {
          mobileOpertor = "МТС";
        }

        const row = {
          ...device,
          ...unit,
          id: unit.id,
          deviceId: device.id,
          title: rows.length === 0 ? unit.title : "",
          registerNumber: rows.length === 0 ? unit.registerNumber : "",
          guaranteeStartDate: new Date(Date.parse(device.guaranteeStartDate)),
          mobileOpertor,
        };

        rows.push(row);
      });

      units = units.concat(rows);
    });

    return units;
  }

  getColumns() {
    const { onViewHistoryUnit, onViewPanelUnit, onViewHistoryDevice, onViewDevicePanel, protocolMarkers } = this.props;

    const renderTypeCell = (params) => {
      return protocolMarkers === null ? "" : protocolMarkers.protocolMarkers.filter((x) => x.value === params.row.type)[0].title;
    };

    const renderSensorCell = (params) => {
      return (
        <div style={{ display: "flex", fontSize: "11px" }}>
          {Object.keys(params.value).map((key, index) => {
            return (
              <div key={index}>
                <TooltipWrapper title={params.value[key]} position="top">
                  <div>{key}&nbsp;</div>
                </TooltipWrapper>
              </div>
            );
          })}
        </div>
      );
    };

    const renderRegisterNumberCell = (params) => {
      return (
        <div style={{ display: "flex", fontSize: "11px", alignItems: "center" }}>
          <div
            onClick={() => {
              onViewHistoryUnit(params.row.id, params.row.title, params.row.registerNumber);
            }}
          >
            <TooltipWrapper title={`Открыть панель истории ${params.row.title} ${params.row.registerNumber}`} position="top">
              <div className={styles.activetyHover}>
                <HistoryIcon fontSize="small" />
              </div>
            </TooltipWrapper>
          </div>

          <TooltipWrapper title={`Открыть панель действий с ${params.row.title} ${params.row.registerNumber}`} position="top">
            <div
              className={styles.activetyHover}
              onClick={() => {
                if (this.props.data.permissions.includes(11001)) {
                  onViewPanelUnit(params.row.id, params.row.title, params.row.registerNumber);
                }
              }}
            >
              {params.value}
            </div>
          </TooltipWrapper>
        </div>
      );
    };

    const renderImeiCell = (params) => {
      const type = renderTypeCell(params);
      return (
        <div style={{ display: "flex", fontSize: "11px", alignItems: "center" }}>
          <div
            onClick={() => {
              onViewHistoryDevice(params.row.deviceId, params.value, type);
            }}
          >
            <TooltipWrapper title={`Открыть панель истории устройства ${params.value} ${type}`} position="top">
              <div className={styles.activetyHover}>
                <HistoryIcon fontSize="small" />
              </div>
            </TooltipWrapper>
          </div>
          <TooltipWrapper title={`Открыть панель настроек устройства ${params.value} ${type}`} position="top">
            <div
              onClick={() => {
                onViewDevicePanel(params.row.deviceId);
              }}
              className={styles.activetyHover}
            >
              {params.value}
            </div>
          </TooltipWrapper>
        </div>
      );
    };

    const styleInactive = (params) => {
      return clsx("inActive-cell", {
        inActiveNegative: params.value,
      });
    };

    const styleGuarantee = (params) => {
      let guaranteeStartDate = new Date(params.row.guaranteeStartDate.getTime());
      guaranteeStartDate = guaranteeStartDate.setMonth(guaranteeStartDate.getMonth() + params.row.guaranteeMounths);

      return clsx("inActive-cell", {
        inActiveNegative: guaranteeStartDate < new Date().getTime(),
      });
    };

    return [
      {
        field: "number",
        headerName: "№",
        width: 40,
      },
      {
        field: "title",
        headerName: "Подпись",
        width: 130,
      },
      {
        field: "registerNumber",
        headerName: "Регистрационный номер ",
        renderCell: renderRegisterNumberCell,
        width: 130,
      },
      {
        field: "imei",
        headerName: "IMEI",
        renderCell: renderImeiCell,
        width: 180,
      },
      {
        field: "numberSim",
        headerName: "Номер SIM",
        width: 180,
      },
      {
        field: "mobileOpertor",
        headerName: "Операто",
        width: 60,
      },
      {
        field: "phone",
        headerName: "Телефон",
        width: 150,
      },
      {
        field: "sensors",
        headerName: "Датчики",
        renderCell: renderSensorCell,
        width: 200,
      },

      {
        field: "type",
        headerName: "Устройство",
        renderCell: renderTypeCell,
        width: 100,
      },
      {
        field: "model",
        headerName: "Модель",
        width: 130,
      },
      {
        field: "command",
        headerName: "Команда",
        width: 100,
      },
      {
        field: "isRent",
        headerName: "В аренде",
        type: "boolean",
        width: 100,
      },
      {
        field: "guaranteeStartDate",
        headerName: "Гарантия с",
        cellClassName: styleGuarantee,
        type: "date",
        width: 100,
      },
      {
        field: "guaranteeMounths",
        headerName: "Срок (мес.)",
        cellClassName: styleGuarantee,
        width: 100,
      },
      {
        field: "inActive",
        headerName: "Неактивна",
        type: "boolean",
        cellClassName: styleInactive,
        width: 100,
      },
    ];
  }

  onDownloadClickHandle() {
    const { onDownloadCompanyInfo, company } = this.props;
    const { activeType, rentType } = this.state;

    onDownloadCompanyInfo(company, { activeType, rentType });
  }

  render() {
    const { company, onSelectUnitHandler, downloadCompanyInfo, data } = this.props;
    const { activeType, rentType } = this.state;

    const datePayment = new Date(Date.parse(company.datePayment));
    const dateCreation = new Date(Date.parse(company.dateCreation));

    return (
      <div>
        <div className={styles.cmsCompanyTableInfo}>
          <div>Срок хранения данных: {company.storagePeriod} (мес.)</div>
          <div>Всего устройств: {company.deviceCount}</div>
          <div>Всего устройств в аренде: {company.rentCount}</div>
          <div>Всего транспортных средств: {company.unitCount}</div>
          {company.unitInActiveCount > 0 ? (
            <div>Всего активных транспортных средств: {Math.abs(company.unitCount - company.unitInActiveCount)}</div>
          ) : null}
          {company.unitInActiveCount > 0 ? <div>Всего не активных транспортных средств: {company.unitInActiveCount}</div> : null}
          <div>
            Дата создания компании:{" "}
            {getDates.getDateFormat1(new Date(dateCreation.setHours(-new Date().getTimezoneOffset() / 60 + dateCreation.getHours())))}
          </div>
          <div>
            {new Date(Date.parse(company.datePayment)) < new Date() ? "Задолженость с: " : "Олаченно до: "}
            {getDates.getDateFormat1(new Date(datePayment.setHours(-new Date().getTimezoneOffset() / 60 + datePayment.getHours())))}
          </div>
        </div>

        {data.permissions.includes(10007) ? (
          <div className={styles.downloadContainer}>
            {downloadCompanyInfo === states.REQUEST ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Preloader />
              </div>
            ) : (
              <ButtonIconWrapper type={"primary"} icon="save" disabled={false} handleClick={this.onDownloadClickHandle.bind(this)} />
            )}

            <div> Скачать список ТС</div>
            <div
              onClick={() => {
                this.setState({ activeType: 0 });
              }}
            >
              <Radio className={styles.MuiRadio_resolve} checked={activeType === 0} size="small" style={{ padding: "0px !important" }} />
              <span>Все</span>
            </div>

            <div
              onClick={() => {
                this.setState({ activeType: 1 });
              }}
            >
              <Radio className={styles.MuiRadio_resolve} checked={activeType === 1} size="small" style={{ padding: "0px !important" }} />
              <span>Активные</span>
            </div>

            <div
              onClick={() => {
                this.setState({ activeType: 2 });
              }}
            >
              <Radio className={styles.MuiRadio_resolve} checked={activeType === 2} size="small" style={{ padding: "0px !important" }} />
              <span>Неактивные</span>
            </div>

            <div
              onClick={() => {
                this.setState({ rentType: 0 });
              }}
            >
              <Radio className={styles.MuiRadio_resolve} checked={rentType === 0} size="small" style={{ padding: "0px !important" }} />
              <span>Арендован, неарендован</span>
            </div>

            <div
              onClick={() => {
                this.setState({ rentType: 1 });
              }}
            >
              <Radio className={styles.MuiRadio_resolve} checked={rentType === 1} size="small" style={{ padding: "0px !important" }} />
              <span>Арендован</span>
            </div>

            <div
              onClick={() => {
                this.setState({ rentType: 2 });
              }}
            >
              <Radio className={styles.MuiRadio_resolve} checked={rentType === 2} size="small" style={{ padding: "0px !important" }} />
              <span>Неарендован</span>
            </div>
          </div>
        ) : null}

        <div className={styles.cmsCompanyTable}>
          <DataGrid
            rowHeight={30}
            ref={"DataGrid"}
            localeText={{
              ...dateGridLocalTextOptions,
              footerRowSelected: (count) => `Транспортных средств выбранно: ${count}`,
              MuiTablePagination: {
                disabled: false,
                rowsPerPage: 100,
                rowsPerPageOptions: 100,
                labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} из ${count === -1 ? `больше ${to}` : count}`,
              },
            }}
            checkboxSelection={this.props.data.permissions.includes(10005)}
            rows={this.getUnits()}
            columns={this.getColumns()}
            disableRowSelectionOnClick
            onRowSelectionModelChange={onSelectUnitHandler}
          />
        </div>
      </div>
    );
  }
}

export default withCompanies(withDevices(withAuth(CmsCompanyTable)));
